module.exports = __webpack_public_path__ + "static/media/notify.5886f557.ogg";